$(window).on('load', () => {

    $('.lazybg').each((i, e) => {

        var lazy = $(e);
        var src = lazy.attr('data-src');

        $('<img>').attr('src', src).imagesLoaded(() => {

            lazy.css('background-image', 'url("' + src + '")');

            if(lazy.attr('data-on-loaded')) {

              eval('window.' + lazy.attr('data-on-loaded') + '()');

            }

        });

    });

});